import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, isExist, getUrlWithQuery } from "cxa-utils";
import { Loader } from "cxa-components";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import { selectHealthReviewTab } from "actions/hraResultActions";
import ProductLink from "components/common/ProductLink";
import { pushDataLayer } from "analytics";
import moment from "moment";
import StandardMoney from "../../../common/StandardMoney";

const renderRiskDetails = ({ riskDetails = [], riskDetails: { length = 0 } }) =>
  length > 0 &&
  riskDetails.map(item => (
    <div key={item.userHealthRiskDetailId}>
      <h3 className={item.riskStatus}>
        <FormattedMessage id={(item.remark || "").trim()} defaultMessage={item.remark} />
      </h3>
      <p>
        <FormattedMessage id={(item.feedback || "").trim()} defaultMessage={item.feedback} />
      </p>
    </div>
  ));

const getAnalyticsLabelFromData = data => {
  const { productId, productName } = data;

  return [
    window.location.href,
    moment().format(moment.defaultFormatUtc),
    productId ? productId : productName,
  ].join("@");
};

const handleSuggestedItemClick = data => {
  pushDataLayer({
    event: "Recommendation item click",
    event_action: "Recommendation item click",
    event_label: getAnalyticsLabelFromData(data),
  });
};

const renderSuggestedOffers = ({ items, selectedLanguage }) => {
  if (isEmpty(items)) {
    return null;
  }

  return (
    <div className="grid__wrapper showcase">
      {items
        .slice(0, 4)
        .map(
          ({
            productId,
            productName,
            imageMainFull,
            providerName,
            sellingPriceIncludingGst,
            currency,
            productUrl,
          }) => {
            let url = `/shop/health-wellness/${productId}`;

            if (isExist(productUrl)) {
              const { code: langCode = "" } = selectedLanguage;

              url = getUrlWithQuery(productUrl, { langid: langCode.replace("-", "") });
            }

            return (
              <article key={productId} className="grid__item grid__item--three showcase__item">
                <figure>
                  <img src={imageMainFull} alt="" />
                </figure>
                <header>
                  <h4>
                    <ProductLink
                      url={url}
                      externalProductUrl={url}
                      productName={productName}
                      onClick={() =>
                        handleSuggestedItemClick({ productId: productId, productName: productName })
                      }
                    />
                  </h4>
                </header>
                <section>
                  <p>
                    <FormattedMessage
                      {...messages.byValueDescription}
                      values={{ value0: providerName }}
                    />
                  </p>
                  <p className="showcase__price">
                    <StandardMoney value={sellingPriceIncludingGst} currency={currency} />
                  </p>
                </section>
              </article>
            );
          }
        )}
    </div>
  );
};

renderSuggestedOffers.propTypes = {
  items: PropTypes.array,
  selectedLanguage: PropTypes.object,
};

renderSuggestedOffers.defaultProps = {
  selectedLanguage: {},
};

const renderQuickTips = items =>
  items &&
  items.length !== 0 && (
    <div className="grid__wrapper">
      {items.map(item => (
        <div key={item.quickTipId} className="grid__item grid__item--two">
          <img src={`/assets/images/wellness/quicktips/${item.quickTipTag}.png`} alt="" />
          <p>
            <FormattedMessage id={item.quickTipText} defaultMessage={item.quickTipText} />
          </p>
        </div>
      ))}
    </div>
  );

const renderLearnMore = items =>
  items &&
  items.length !== 0 && (
    <div className="grid__wrapper showcase">
      {items.slice(0, 4).map(item => (
        <article key={item.contentId} className="grid__item grid__item--three showcase__item">
          <figure>
            <img
              src={item.imageMainFull ? item.imageMainFull : item.coverImageDefaultFull}
              alt={item.title}
            />
          </figure>
          <header>
            <h4>
              <Link to={`/wellness/elibrary/catalogue/${item.detailsKey}`}>
                <FormattedMessage id={item.title} defaultMessage={item.title} />
              </Link>
            </h4>
          </header>
          <section>
            <p>
              <FormattedMessage id={item.providerName} defaultMessage={item.providerName} />
            </p>
            <div dangerouslySetInnerHTML={{ __html: item.summary }} />
          </section>
        </article>
      ))}
    </div>
  );

class ResultDetail extends Component {
  tabSelected = (index, lastIndex) => {
    if (lastIndex === index) {
      return;
    }

    const { selectHealthReviewTab } = this.props;

    selectHealthReviewTab(index);
  };

  render() {
    const {
      resultDetail,
      isFetchingHraResultDetail,
      hideHraRecommendation,
      selectedTab,
      selectedLanguage,
    } = this.props;

    if (isFetchingHraResultDetail || isEmpty(resultDetail)) {
      return <Loader />;
    }

    const { quickTips, shopItems, newShopRecommendation, libraryItems } = resultDetail;

    const tabs = [
      {
        name: "Suggested Offers",
        content: renderSuggestedOffers({
          items: newShopRecommendation || shopItems,
          selectedLanguage,
        }),
      },
      {
        name: "Quick Tips",
        title: "Quick Tips",
        content: renderQuickTips(quickTips),
      },
      {
        name: "Learn More",
        content: renderLearnMore(libraryItems),
      },
    ].filter(item => !!item.content);

    return (
      <div>
        {!hideHraRecommendation && renderRiskDetails(resultDetail)}
        <Tabs onSelect={this.tabSelected} selectedIndex={selectedTab}>
          <TabList>
            {tabs.map(item => (
              <Tab key={item.name}>
                <FormattedMessage id={item.name} defaultMessage={item.name} />
              </Tab>
            ))}
          </TabList>
          {tabs.map(item => (
            <TabPanel key={item.name}>{item.content}</TabPanel>
          ))}
        </Tabs>
      </div>
    );
  }
}

ResultDetail.propTypes = {
  error: PropTypes.object,
  isFetchingHraResultDetail: PropTypes.bool,
  resultDetail: PropTypes.object,
  chagePhotos: PropTypes.func,
  hideHraRecommendation: PropTypes.bool,
  riskDomain: PropTypes.string,
  selectHealthReviewTab: PropTypes.func,
  selectedTab: PropTypes.number,
  selectedLanguage: PropTypes.object,
};

const mapStateToProps = ({
  error,
  localization: { selectedLanguage },
  hraResult: { hideHraRecommendation },
  hraResultDetail: { isFetching, resultDetail, currentRiskDomain, selectedTab },
}) => ({
  isFetchingHraResultDetail: isFetching,
  riskDomain: currentRiskDomain,
  selectedLanguage,
  error,
  resultDetail,
  hideHraRecommendation,
  selectedTab,
});

const mapDispatchToProps = {
  selectHealthReviewTab,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultDetail);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/ResultDetail.js